<template>
  <div class="offer">
    <div>
      <p class="offer--amount">{{ amount }}</p>
      <p class="offer--subtitle">Made via {{ type.toLowerCase() }} by {{ madeBy }} on {{ date }}</p>
    </div>

    <div>
      <button-icon
        icon="edit"
        color="is-secondary"
        @click="editBuyingOffer(offer)"
      ></button-icon>
    </div>
  </div>
</template>

<script>
import AnalysisItem from "./AnalysisItem";
import {ENUMS} from "../../../services/enums";
import dates from "../../../services/dates";

export default {
  name: "BuyingOfferItem",
  components: {AnalysisItem},
  props: {
    offer: {
      type: Object,
      required: true
    }
  },
  computed: {
    amount() {
      return this.$utils.formatCurrency(this.offer.amount);
    },
    type() {
      return this.$utils.newGetEnumLabel(this.offer.type, ENUMS.BuyingOfferTypeEnum);
    },
    madeBy() {
      const user = this.$store.getters.users.find(u => u.id === this.offer.made_by);

      if(user) {
        return user.full_name;
      } else {
        return 'Seller';
      }
    },
    date() {
      return dates.formatAsDate(this.offer.date, false, true);
    }
  },
  methods: {
    editBuyingOffer(buyingOffer) {
      this.$emit('edit', buyingOffer);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.offer {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;

  &--amount {
    margin-bottom: 6px;
    font-size: 1.25rem;
    color: $primary;
  }

  &--subtitle {
    font-size: 0.75rem;
  }
}

</style>
